<template>
<BootstrapDialog title="直播学习资料" ref="dialog" size="lg" @afterOpen="afterOpen()" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-9 col-sm-offset-1">
					<h4 class="m-t-none m-b font-thin"><i class="fa fa-plus" aria-hidden="true"></i>添加学习资料</h4>
		            <form role="form" class="form-horizontal" id="pldr_form">
		                <div class="form-group">
		                    <label class="col-sm-2 control-label">请选择文件</label>
		                    <div class="col-sm-8">
		                        <file-upload id="zypx_zcxx_bt_imp_fp" @fileselected="fileselected"></file-upload>
		                    </div>
		                    <div class="col-sm-1" style="padding-left: 0px;">
								<button class="btn btn-primary btn-sm" type="button" @click="save()"><i class="fa fa-check"></i>保存</button>
							</div>
		                </div>
		            </form>
					<div style="margin-top:2px">
							<BootstrapTable style="font-size: 14px;"
							        ref="table"
							        v-once
							        :columns="columns"
							        :options="{
												classes:'table table-hover',
							        			undefinedText:'',
							                    showColumns: false,
							                    sidePagination:'server',
							                    pagination:true,
							                    pageNumber:1,
							                    pageSize:10,
							                    pageList:[10,50,100,500],
							                    paginationPreText:'上一页',
							                    paginationNextText:'下一页',
							                    showExtendedPagination:true,
							                    paginationLoop:false
							         }"
							        @onPostBody="vueFormatterPostBody"
							        @onPageChange="pageChange"
							/>
					</div>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 添加直播的学习资料
     */
	import tableMixin from '@/mixins/table.js';  //表格
    export default {
		mixins: [tableMixin],
        name:'ZbXxzlAdd',
        data:function(){
            return {
               file:null,
			   query:{
				   zbId:''
			   },
			   columns:[
				   {
				       title: '序号',
				       field: 'id',
				       align: 'center',
				       formatter: (value, row, index)=> {
				           var options = this.$refs.table.getOptions();
				           return options.pageSize * (options.pageNumber - 1) + index + 1;
				       }
				   },
				   {
				       field: 'fjmc',
				       title: '学习资料',
					   formatter: (value, row) => {
					       return row.fjmc+'('+row.showSize+")";
					   }
				   },
				   {
				       field: 'actions',
				       title: '操作',
				       align: 'center',
				       formatter: (value, row) => {
				   		let html="";
				   		html += '<a target="_blank" href="'+row.xxdz+'">下载</a> | ';
				   		html += '<a @click="remove(row)">删除</a>';
				        return this.vueFormatter({
				               template: '<div class="operation_column">'
				   						+html
				   					+'</div>',
				               data: { row },
				               methods: {
				                   remove: this.remove
				               }
				           })
				       }
				   }
			   ]
            }
        },
        methods:{
			reset:function(){
				this.file = null;
				this.query = {
					zbId:''
				};
				let result= {
				    total: 0,
				    rows: []
				};
				//table加载返回的数据
				this.$refs.table.load(result);
			},
			open:function(params){
				$('#pldr_form').find('.form-control').val('');
				this.query.zbId = params.zbId;
				this.$refs.dialog.open();
			},
			afterOpen:function(){
				this.load(1,10);
			},
			close:function(){
				this.$refs.dialog.close();
			},
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
			remove:function(row){
				this.$confirm('确定删除这个资料吗？',()=>{
					this.$http.post('/htgl/biz/zypx/zb/delXxzl',{id:row.id}).then(res=>{
						if(res.data){
							this.$success('操作成功',()=>{
								this.search();//刷新列表
							});
						}
					});
				});
			},
			search:function(){
			    //将数据表格的页码以及每一页展示的数据重置为1，10
			    this.$refs.table.refreshOptions({pageNumber:1, pageSize:10});
			    this.load(1,10);
			},
            fileselected:function(file){
                this.file = file;
            },
			load:function(pageNumber, pageSize){
			    this.query.current = pageNumber || this.query.current;
			    this.query.size = pageSize || this.query.size;
			    this.$http.post('/htgl/biz/zypx/zb/pageQueryXxzl',this.query).then(res=>{
			        let data = res.data;
			        //封装返回值
			        let result= {
			            total: data.total,
			            rows: data.records
			        };
			        //table加载返回的数据
			        this.$refs.table.load(result);
			    });
			},
			pageChange:function(pageNumber, pageSize){
			    this.load(pageNumber, pageSize);
			},
            save:function(){
                if(this.file){
                    let formdata = new FormData();
                    formdata.append("file",this.file);
					formdata.append("zbId",this.query.zbId);
                    console.log("-----A file",this.file);
                    this.$http.post("/htgl/biz/zypx/zb/addXxzl",formdata,{'Content-Type':'multipart/form-data'}).then(res=>{
                        if(res.data){
							this.$success('操作成功',()=>{
								this.search();
							});
                        }
                    })
                }
                else{
					this.$error('请选择需要上传的资料');
                }
            }
        }
    }
</script>
